<template>
    <div class="personal-info">
        <el-form :model="userInfo" label-width="80px" :rules="rules" ref="personalForm" size="small">
            <el-form-item label="头像" style="margin-bottom: 0 !important;">
                <div class="avatar-wrap">
                    <file-upload class="avatar-uploader" action="/image/upload" :isPermanent="true" :showLoading="true"
                        :maxSize="maxSize" @success="onUploadSuccess"
                        :fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp']">
                        <img v-if="userInfo.headImage" :src="$mediaUrl(userInfo.headImage)" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </file-upload>
                    <official-tag :user-tag="userInfo.userTag" size="large"></official-tag>
                </div>
            </el-form-item>
            <el-form-item label="二维码">
                <div class="qrcode-btn" @click="handleShowQrcode">我的二维码</div>
            </el-form-item>
            <el-form-item label="用户ID">
                <el-input readOnly v-model="userInfo.id" autocomplete="off" size="small"></el-input>
            </el-form-item>
            <el-form-item prop="nickName" label="昵称">
                <div class="nick-name-row">
                    <el-input v-model="userInfo.nickName" autocomplete="off" size="small"
                        :class="{ 'official-name-input': userInfo.userTag == 1 }"></el-input>
                </div>
            </el-form-item>
            <el-form-item label="性别">
                <el-radio-group v-model="userInfo.sex">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label="1">女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="userInfo.phone" label="手机号">
                <el-input readOnly v-model="userInfo.phone" autocomplete="off" size="small"></el-input>
            </el-form-item>
            <el-form-item v-if="userInfo.email" label="邮箱">
                <el-input readOnly v-model="userInfo.email" autocomplete="off" size="small"></el-input>
            </el-form-item>
            <el-form-item label="个性签名">
                <el-input type="textarea" v-model="userInfo.signature" :rows="3" maxlength="64" placeholder="编辑个性签名，展示我的独特态度"></el-input>
            </el-form-item>
        </el-form>
        <div class="btn-group">
            <el-button type="primary" @click="onSubmit()" size="large">提 交</el-button>
        </div>
    </div>
</template>

<script>
import FileUpload from "../common/FileUpload.vue";
import OfficialTag from "../common/OfficialTag.vue";

export default {
    name: "personalInfo",
    components: {
        FileUpload,
        OfficialTag,
    },
    data() {
        return {
            userInfo: {},
            maxSize: 5 * 1024 * 1024,
            action: "/image/upload",
            rules: {
                nickName: [{
                    required: true,
                    message: '请输入昵称',
                    trigger: 'blur'
                }]
            },
        }
    },
    methods: {
        handleShowQrcode() {
            this.$emit("showQrcodeCall")
        },
        init() {
            let mine = this.$store.state.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
        },
        onSubmit() {
            this.$refs.personalForm.validate((valid) => {
                if (!valid) {
                    return false;
                }
                this.$http({
                    url: "/user/update",
                    method: "put",
                    data: this.userInfo
                }).then(() => {
                    this.$store.dispatch("loadUser")
                    this.$message.success("修改成功");
                })
            });
        },
        onUploadSuccess(data, file) {
            this.userInfo.headImage = data.originUrl;
            this.userInfo.headImageThumb = data.originUrl || data.thumbUrl;
        }
    }

}
</script>

<style lang="scss">
.personal-info {
    padding: 10px 0 0 10px;
    .qrcode-btn {
        color: var(--im-color-primary);
        cursor: pointer;
    }
    .avatar-wrap {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    .nick-name-row {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-input {
            flex: 1;
        }

        .official-name-input .el-input__inner {
            font-weight: 700;
            color: #f5222d;
        }
    }
    .avatar-uploader {
        --width: 112px;

        .el-upload {
            border: 1px dashed #d9d9d9 !important;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }

        .el-upload:hover {
            border-color: #409EFF;
        }

        .avatar-uploader-icon {
            font-size: 24px;
            color: #8c939d;
            width: var(--width);
            height: var(--width);
            line-height: var(--width);
            text-align: center;
        }

        .avatar {
            width: var(--width);
            height: var(--width);
            display: block;
        }
    }

    .btn-group {
        text-align: center;
    }
}
</style>
